import cn from 'classnames'
import settings from '../../settings'

import { useLanguageMenu } from 'mmfintech-checkout-commons'

import ArrowUpIcon from '../../assets/icons/arrow-up.svg?react'
import ArrowDownIcon from '../../assets/icons/arrow-down.svg?react'

import './languageMenu.scss'

const LanguageMenu = () => {
  const {
    dropdownOpened,
    selectedLanguage,
    languages,
    getLanguageName,
    handleDropDownClick,
    handleLanguageChange,
    setRef
  } = useLanguageMenu(settings.languages)

  return selectedLanguage ? (
    <div className='language-menu-wrapper' data-test='language-menu-wrapper' ref={setRef}>
      <div className={cn('menu-container', { opened: dropdownOpened })} onClick={handleDropDownClick}>
        <span className='selected'>{getLanguageName(selectedLanguage)}</span>
        <span className='arrow'>{dropdownOpened ? <ArrowUpIcon /> : <ArrowDownIcon />}</span>
      </div>
      <div className={cn('menu-dropdown', { opened: dropdownOpened })} data-test='language-menu-content'>
        <ul data-test='language-menu-list'>
          {languages.map(v => (
            <li key={v.code} onClick={() => handleLanguageChange(v.code)} data-test='language-menu-item'>
              {v.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null
}

export default LanguageMenu
